export const isClickOutside = (el, event) => {
  /* istanbul ignore next */
  return !(el === event.target || el.contains(event.target));
};

/**
 * Triggers a given method on clicking outside an element
 * @returns {undefined}
 */
export const clickoutside = {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      /* istanbul ignore next */
      if (isClickOutside(el, event)) {
        vnode.context[binding.expression](event);
      }
    };

    document.body.addEventListener('click', el.clickOutsideEvent);
  },

  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
};
